"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _utils = require("promo-animation/dist/utils");

var _utils2 = require("./utils");

var _reportsService = _interopRequireDefault(require("./service/reports-service"));

var _apiService = _interopRequireDefault(require("./service/api-service"));

var errors = _interopRequireWildcard(require("./service/errors-const"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const defaultDataFromList = require('./utils/defaults-utils');

let settings = {
  device: null
};
let apis;
let reportService;
let appData;
/**
 * Main app api
 * @param {object} config  { device: and or ios, logger: window.console}
 * @param {function} asyncCallback  callback function for async operator
 */

class Api {
  constructor(config, asyncCallback) {
    apis = new Map();
    this.config = config;
    this.logger = config.logger || console;

    this.asyncCallback = asyncCallback || function () {
      this.logger.warn('asyncCallback was not set');
    };

    settings = { ...settings,
      ...config
    }; // set caption default config if needed

    if (!config.hasOwnProperty('caption')) {
      config.caption = { ...defaultDataFromList((0, _utils.GetAllTemplates)())
      };
    }

    this.service = new _apiService.default({ ...config,
      logger: this.logger
    }); // privet service

    reportService = new _reportsService.default({ ...config,
      logger: this.logger
    });
    this.asyncCallback((0, _utils2.getResponseObject)('success', {
      message: 'js api ready'
    }));
  }

  addAPI(name, __class, config = {}) {
    this[name] = new __class({ ...config,
      ...this.config,
      logger: this.logger
    }, this.asyncCallback);

    if (appData) {
      this[name].promoVideoData = appData.promoVideoData;
    }

    apis.set(name, this[name]);
    this.asyncCallback((0, _utils2.getResponseObject)('success', {
      message: `js api.${name} ready`
    }));
  }
  /**
  * This function create a new promo video data from the thie create from-[###] request data
  * validate video version and set valid promo video object
  * return object with captions and clips lists
  * @param {object} data  promo video data respons object or bash64 string
  * @returns {object} { status: 'success', statusMsg: '', payload: { captions: array , clips: array, music: array }}
  */


  createNewPromo(data) {
    if (_.isString(data)) {
      appData = JSON.parse((0, _utils2.b64DecodeUnicode)(data));
    } else {
      appData = data;
    }

    try {
      const {
        promoVideoData,
        state
      } = appData;
      appData.promoVideoData = this.service.preperPromoVideoData(promoVideoData, state); // set promoVideoData to the apis

      apis.forEach(item => {
        item.promoVideoData = appData.promoVideoData;
      });
      const {
        decoration,
        clips,
        music
      } = appData.promoVideoData;
      const captions = (0, _utils2.getNormalizeCaptions)(decoration.decorationData, this.config.caption);
      const configRatio = captions[0].data.ratio;

      if (configRatio) {
        appData.promoVideoData.ratio = configRatio;
      }

      return (0, _utils2.getResponseObject)('success', {
        captions,
        clips: (0, _utils2.getNormalizeClips)(clips),
        music: [...music],
        brandId: appData.promoVideoData.brandId || null,
        config: (0, _utils2.getConfigOptionObject)(appData),
        ratio: (0, _utils2.getRatioObjectBy)('ratio', appData.promoVideoData.ratio)
      });
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function return the async api object.
  * @param {string =} action
  * @returns {object} { status: 'success', statusMsg: '', payload: { async:data object, config: object }
  * @example const asyncData =  api.getAsyncData('createFinalVideo');
  */


  getAsyncData(action) {
    // TODO: need to set clips and transition
    try {
      appData.promoVideoData = this.service.updatePromoVideoData(appData.promoVideoData);
      const {
        promoVideoData
      } = appData;
      const payload = {
        async: {
          api: {
            action: action || appData.action || 'initVideo'
          },
          video: Object.assign({}, (0, _utils2.cleanDataFromPromoVideo)(promoVideoData), // return immutable promo video data after clean ups
          (0, _utils2.getVideoScript)(promoVideoData), // return video scrip layers
          {
            reportsData: reportService.getReportsObject(promoVideoData)
          })
        },
        config: {
          creationTimeEstimate: (0, _utils2.getCreationTimeEstimate)(promoVideoData)
        }
      };
      return (0, _utils2.getResponseObject)('success', payload);
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
   * This function return the mock data of template for admin.
   * @param {string } templateName
   * @returns {object} { status: 'success', statusMsg: '', payload: { mockdata }
   * @example const mockData =  api.getTemplateMockData('template12');
   */


  getTemplateMockData(templateName) {
    return this.service.prepareTemplate2MockData(templateName);
  }
  /**
   * This function set recommended audio tracks,
   * can pass all or one of the inputs to be updated
   * @param {array} tracks  array with id's
   * @returns {object} { status: 'success', statusMsg: '', payload: {captions: array}}
   * @example api.setRecommendedAudio([
   * '5d134de',
   * '532df23e'
   * ])
   */


  setRecommendedAudio(tracks) {
    try {
      if (!_.isArray(tracks)) {
        throw errors.INVALID_PARMS;
      }

      appData.promoVideoData.recommendedAudioIds = tracks;
      return (0, _utils2.getResponseObject)('success', { ...appData
      });
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function set the video id in promoVideoData.
  * @param {string} videoId
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example const asyncData =  api.setVideoId('5b9f79a49f700255568b456d');
  */


  setVideoId(videoId) {
    try {
      const {
        promoVideoData
      } = appData;
      promoVideoData.hash = videoId;

      if (appData.action === 'initVideo') {
        appData.action = 'updateVideo';
      }

      return (0, _utils2.getResponseObject)('success', {});
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function set the brand id in promoVideoData.
  * @param {string} brandId
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example const asyncData =  api.setBrandId('5ccaf3383ff470cad73471d3');
  */


  setBrandId(brandId) {
    try {
      const {
        promoVideoData
      } = appData;
      promoVideoData.brandId = brandId;
      return (0, _utils2.getResponseObject)('success', {});
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function sets the video scale in promoVideoData.
  * @param {string} scale
  * @returns {object} { status: 'success', statusMsg: '', payload: {} }
  * @example const asyncData =  api.setVideoScale('1.5');
  */


  setVideoScale(scale) {
    try {
      const {
        promoVideoData
      } = appData;
      promoVideoData.videoScale = scale;
      return (0, _utils2.getResponseObject)('success', {});
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function set the music track in the music array
  * @param {object} musicClip  music clip object as base64 string
  * @returns {object} { status: 'success', statusMsg: '', payload: { music:array }
  * @example api.setMusic({
  *   track: {
  *       artist: "Amado, Studer",
  *       id: "577e2b14374e274a357b23c7",
  *       isUpload: false,
  *       thumbnailUrl: "https://ak03-cdn.slidely.com/media/audio-thumbs/57/6a/576a9bd82d30e683388b46d1.jpg",
  *       title: "Madcap Caper",
  *       type: "library",
  *       url: "https://ak01-cdn.slidely.com/media/audio/b6/6c/b66ccaa85030e5c79e2a7fe7995a32de-15.mp3?dv=1"
  *   }
  * });
  * // for uploaded music that not was trim
  *  api.setMusic({
  *   track: {
  *       artist: "f12c889d5169b418609f5d4c1e8f4f33-15.mp3",
  *       id: "5c0d1d6476e0df23737b2482",
  *       isUpload: true,
  *       thumbnailUrl: "https://ak01-cdn.slidely.com/media/audio-thumbs/57/6a/576a9a0f2d30e683388b4569.jpg",
  *       title: "ran rischin",
  *       type: "upload",
  *       url: "https://ak04-cdn.slidely.com/pvUploadedAudios/5c/0d/5c0d1d6476e0df23737b2482-uploaded-audio.mp3?dv=1"
  *   }
  * });
  * // for uploaded music that was trim
  *  api.setMusic({
  *   end: "7.3893022923",
  *   isFadeOut: true,
  *   start: "3.5302521490",
  *   track: {
  *       artist: "f12c889d5169b418609f5d4c1e8f4f33-15.mp3",
  *       id: "5c0d1d6476e0df23737b2482",
  *       isUpload: true,
  *       thumbnailUrl: "https://ak01-cdn.slidely.com/media/audio-thumbs/57/6a/576a9a0f2d30e683388b4569.jpg",
  *       title: "ran rischin",
  *       type: "upload",
  *       url: "https://ak04-cdn.slidely.com/pvUploadedAudios/5c/0d/5c0d1d6476e0df23737b2482-uploaded-audio.mp3?dv=1"
  *   }
  * });
  */


  setMusic(musicClip) {
    // TODO: add validation and service for the set music
    try {
      let mc = musicClip;

      if (_.isString(musicClip)) {
        mc = JSON.parse((0, _utils2.b64DecodeUnicode)(musicClip));
      }

      appData.promoVideoData.music[0] = mc;
      return (0, _utils2.getResponseObject)('success', {
        music: [...appData.promoVideoData.music]
      });
    } catch (error) {
      return (0, _utils2.getResponseObject)('error', error);
    }
  }
  /**
  * This function set no music for the video
  * @returns {object} { status: 'success', statusMsg: '', payload: { music:array }
  * @example api.setNoMusic();
  */


  setNoMusic() {
    return this.setMusic({
      track: {
        id: '5d2eda2ce38d377d1c21d365',
        type: 'library',
        isUploaded: false,
        isUpload: false,
        isSilence: true,
        isNew: false,
        artist: 'Silence',
        title: 'Promo',
        url: 'https://ak04-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-15.mp3?dv=0',
        allDurations: {
          '10sec': 'https://ak04-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-10.mp3?dv=0',
          '15sec': 'https://ak04-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-15.mp3?dv=0',
          '20sec': 'https://ak02-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-20.mp3?dv=0',
          '25sec': 'https://ak02-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-25.mp3?dv=0',
          '30sec': 'https://ak01-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-30.mp3?dv=0',
          'full': 'https://ak03-promo-cdn.slidely.com/media/audio/4a/5a/4a5ab988b129ca7765637bfd83f5db59-full.mp3?dv=0'
        },
        thumbnailUrl: 'https://ak02-promo-cdn.slidely.com/media/audio-thumbs/5d/25/5d25c9812faac11c937a4dfc.jpg'
      }
    });
  }
  /**
  * Get promo video total durarion
  * @returns {float} in sec
  * @example
  * // get
  * const duration = api.duration;
  */


  get duration() {
    return this.service.getDuration(appData.promoVideoData);
  }
  /**
  * Get back raw app data
  * @returns {object}
  * @example
  * // get
  * const appData = api.appData;
  */


  get appData() {
    return appData;
  }

}

exports.default = Api;